import { AppBundle } from 'api/optimalprint-sdk.d';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import getCategoryId from 'store/category/selector/getCategoryId';
import getBundleGroups from '../selector/getBundleGroups';
import getPredesignedProductItems from '../selector/getPredesignedProductItems';
import getSelectedBundleProducts from '../selector/getSelectedBundleProducts';
import { deselectBundleProductAction, resetForcedProductPreviewsAction, selectBundleProductAction } from '../slice';
import forceProductPreviewFromBundleProductsOperation from './forceProductPreviewFromBundleProductsOperation';

type ProductItem = AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.IProductItem;

const updateBundledProductOperation =
  () => (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const selectedBundleProducts = getSelectedBundleProducts(store);
    if (!selectedBundleProducts || !selectedBundleProducts.length || selectedBundleProducts[0].productId === 0) {
      return;
    }

    const selectedProductId = selectedBundleProducts[0].productId;
    const bundleGroups = getBundleGroups(store);

    const deselectBundledProduct = () => {
      dispatch(
        deselectBundleProductAction({
          bundleGroupId: selectedBundleProducts[0].bundleGroupId,
          productItem: {
            productId: selectedBundleProducts[0].productId,
          } as ProductItem,
        }),
      );
    };

    // if current product has no bundled products, deselect currently bundled product
    if (!bundleGroups || !bundleGroups.length || !bundleGroups[0].items) {
      deselectBundledProduct();
      dispatch(resetForcedProductPreviewsAction());
      return;
    }

    const isSelectedProductIdValid = bundleGroups[0].items.find((item) => item.productId === selectedProductId);
    if (isSelectedProductIdValid) {
      return;
    }

    // find bundled product
    const allAvailableProducts = getPredesignedProductItems(store);
    let currentBundledProductItem:
      | AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.IProductItem
      | undefined;
    allAvailableProducts.some((productItem) =>
      productItem.product.bundleGroups?.some((bg) =>
        bg.items?.some((bgItem) => {
          if (bgItem.productId === selectedProductId) {
            currentBundledProductItem = bgItem;
            return true;
          }
          return false;
        }),
      ),
    );
    if (!currentBundledProductItem) {
      deselectBundledProduct();
      return;
    }

    const bestMatchBundledProduct = bundleGroups[0].items.find(
      (productCandidat) =>
        productCandidat.colorTypeId === currentBundledProductItem?.colorTypeId &&
        productCandidat.paperTypeId === currentBundledProductItem?.paperTypeId,
    );
    if (!bestMatchBundledProduct) {
      deselectBundledProduct();
      return;
    }
    const categoryId = getCategoryId(store) || 1;

    dispatch(
      selectBundleProductAction({
        bundleGroupId: bundleGroups[0].bundleGroupId,
        useMultipleSelection: bundleGroups[0].canSelectMultiple,
        productItem: {
          productId: bestMatchBundledProduct.productId,
        } as ProductItem,
        categoryId,
      }),
    );
    dispatch(forceProductPreviewFromBundleProductsOperation());
  };

export default updateBundledProductOperation;
